import currency from 'currency.js';
import { handleNumber } from './util';

const getGrandTotal = (orders, isFormated = true, pass) => {
  let grandTotal = 0;
  orders.forEach((order) => {
    if (order.flag === 'success' || order.flag === 'info' || pass) {
      order.items.forEach((item) => {
        grandTotal += item.sub_total_inc_shipping;
      });
    }
  });
  return isFormated ? handleNumber(grandTotal, 2, true, '$') : grandTotal;
};

function toFixedNumber(num, digs = 2) {
  return parseFloat(num.toFixed(digs));
}

const getGrandTotalWithProcFee = (orders, isFormated = true, pass) => {
  const grandTotal = getGrandTotal(orders, false, pass);
  const processingFee = getProcessingFee(orders, false, pass);
  const price = grandTotal + processingFee;
  return isFormated ? handleNumber(price, 2, true, '$') : price;
};

const getSubTotal = (orders, isFormated = true, pass) => {
  let subTotal = 0;
  orders.forEach((order) => {
    if (order.flag === 'success' || order.flag === 'info' || pass) {
      // subTotal += order.total_amount;
      order.items.forEach((item) => {
        subTotal += item.sub_total_inc_shipping;
      });
    }
  });

  return isFormated ? handleNumber(subTotal, 2, true, '$') : subTotal;
};

const getProcessingFee = (orders, isFormated = true, pass) => {
  let processingFee = 0;
  orders.forEach((order) => {
    if (order.flag === 'success' || order.flag === 'info' || pass) {
      order.items.forEach((item) => {
        // status is not 'unpaid' , regards that user has paid the order
        if (order.status !== 'unpaid') {
          // trust  the processing fee from api
          processingFee += (item.processing_fee || 0) * item.qty;
        } else {
          // keep the same arithmetic as backend
          if (order.country === "NZ") {
            processingFee = currency(item.price)
              .add(item.shipping_fee)
              .multiply(0.011)
              .multiply(1.1)
              .multiply(item.qty)
              .add(processingFee).value;
          } else {
            processingFee = currency(item.price)
              .add(item.shipping_fee)
              .multiply(0.011)
              .multiply(item.qty)
              .add(processingFee).value;
          }
        }
      });
    }
  });

  return isFormated ? handleNumber(processingFee, 2, true, '$') : processingFee;
};

const getGST = (orders, noFee, isFormated = true, pass) => {
  if (isNZGSTApplicable(orders[0].country, orders[0].order_date)) {
    const processingFee = getProcessingFee(orders, false, pass);
    let gst = processingFee / 11;
    if(noFee){
      gst = 0;
    }
    return isFormated ? handleNumber(gst, 2, true, '$') : gst;
  } else {
    const grandTotal = noFee
      ? getGrandTotal(orders, false, pass)
      : getGrandTotalWithProcFee(orders, false, pass);
    const gst = grandTotal / 11;
    return isFormated ? handleNumber(gst, 2, true, '$') : gst;
  }
};

const isNZGSTApplicable = (orderCountry, orderDate) => {
  const nzCutoffDate = process.env.REACT_APP_NZ_GST_CUTOFF_TIME
  const orderDateTimestamp = new Date(orderDate).getTime();
  const cutoffDateTimestamp = new Date(nzCutoffDate).getTime();
  return orderCountry === "NZ" && orderDateTimestamp > cutoffDateTimestamp;
}

const OrderPrice = {
  getGrandTotal,
  getGrandTotalWithProcFee,
  getSubTotal,
  getProcessingFee,
  getGST,
  toFixedNumber,
  isNZGSTApplicable
};

export default OrderPrice;
